import { render } from "./LecheCaliente.vue?vue&type=template&id=3aee3bfd"
import script from "./LecheCaliente.vue?vue&type=script&lang=js"
export * from "./LecheCaliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__